<p-iconfield>
  <input
    id="searchBar"
    readonly
    type="text"
    class="searchbar"
    pInputText
    placeholder="{{ placeholder }}"
    [attr.size]="placeholder ? placeholder.length + 2 : null"
    (click)="onMouseClick($event)"
  />
  <label for="searchBar" class="d-none sr-only">{{ placeholder }}</label>
  <p-inputicon class="pi pi-search searchbar__icon" />
</p-iconfield>
